import { Skeleton } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import ToggleButtonGroup from "@material-ui/core/ToggleButtonGroup";
import React, { useEffect } from "react";
import { EnumMarketplace } from "../../../../../server/routes/marketplace/types";
import useMarketplacesFilter from "../../../components/FilterMarketplacesProvider/useFilterMarketplaces";
import {
  getReduxCookieValue,
  setReduxCookieValue,
} from "../../../utils/cookie";
import MarketplaceButton from "./MarketplaceButton";
import { MarketplaceFilterPanelFC } from "./types";

const MarketplaceFilterPanel: MarketplaceFilterPanelFC = ({}) => {
  const { isLoading, list, active, filtering } = useMarketplacesFilter();

  useEffect(() => {
    const marketplaces = JSON.parse(
      getReduxCookieValue(["page", "dashboard", "marketplaces"], "[]") ?? "[]"
    ) as EnumMarketplace[];
    if (marketplaces.length > 0) {
      filtering(marketplaces);
    }
  }, []);

  const handlerChange = (
    event: React.MouseEvent<HTMLElement>,
    marketplaces: EnumMarketplace[]
  ) => {
    filtering(marketplaces);
    setReduxCookieValue(
      ["page", "dashboard", "marketplaces"],
      JSON.stringify(marketplaces)
    );
  };

  return (
    <Box pb={3}>
      {isLoading && (
        <Box
          sx={{
            display: "flex",
          }}
        >
          {[75, 120, 100].map((width, key) => (
            <Skeleton
              variant={"rectangular"}
              height={40}
              width={width}
              key={key}
              sx={{ borderRadius: "6px" }}
            />
          ))}
        </Box>
      )}
      {list.length > 0 && (
        <ToggleButtonGroup
          color="primary"
          value={active}
          size={"small"}
          onChange={handlerChange}
          sx={{ overflowY: "auto", width: "100%" }}
        >
          {list.map((marketplace) => (
            <MarketplaceButton
              key={marketplace.uid}
              marketplace={marketplace}
            />
          ))}
        </ToggleButtonGroup>
      )}
    </Box>
  );
};

export default MarketplaceFilterPanel;
